<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <h1 class="title-default">
                        Lançamentos Pendentes
                        <span class="title-cartao-tag">Cartão</span>
                    </h1>
                    <p class="welcome-message">
                        <button mat-icon-button (click)="voltar()" matTooltip="Voltar para contas">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Visualize e concilie os lançamentos importados para esta conta.
                    </p>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
                    <span>Ações</span>
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #acoesMenu="matMenu">
                    <button mat-menu-item (click)="irParaConciliados()">
                        <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                        <span>Ver Conciliados</span>
                    </button>
                    <button mat-menu-item (click)="irParaIgnorados()">
                        <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>
                        <span>Ver Ignorados</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <!-- Seletor de conta -->
        <div class="row mb-3 align-items-center">
            <div class="col-sm-12 col-md-12 col-lg-5">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Cartão de Crédito</mat-label>
                    <mat-select [ngModel]="idContaFinanceira" (ngModelChange)="onContaChange($event)">
                        @for (conta of _contas; track conta) {
                        <mat-option [value]="conta.idContaFinanceira">
                            {{ labelConta(conta) }}
                        </mat-option>
                        }
                    </mat-select>
                    @if (agencia) {
                    <mat-hint>Ag. {{ agencia }} · CC {{ numeroConta }}</mat-hint>
                    }
                </mat-form-field>
            </div>
            <div class="col-auto">
                @if (statusConexaoExtrato === statusConexaoEnum.Conectado) {
                <span class="status-badge badge-verde">● API Conectada</span>
                }
                @if (statusConexaoExtrato === statusConexaoEnum.Conectando) {
                <span class="status-badge badge-amarelo">● Conectando...</span>
                }
            </div>
        </div>

        <!-- CTA banner de integração -->
        @if (bancoDaContaSuportaOpenFinance && !statusConexaoExtrato) {
        <app-alert-card type="info" icon="sync_alt" title="Automatize sua conciliação" class="mb-3 d-block">
            <div class="cta-alert-row">
                <span>Configure sua integração Open Finance para importar seus extratos automaticamente e elimine a
                    importação manual.</span>
                <button mat-flat-button class="btn-primary" (click)="irParaConfiguracaoIntegracao()">
                    <mat-icon>link</mat-icon>
                    Configurar integração
                </button>
            </div>
        </app-alert-card>
        }

        <app-alert-card type="info" class="mb-3 d-block">
            Aqui você vincula cada compra do cartão à sua respectiva Conta a Pagar. Para pagar a fatura, basta
            fazer uma transferência da sua conta bancária para a conta do cartão.
        </app-alert-card>

        <!-- Alerta: pendentes fora do período -->
        @if (!isLoading && alertForaPeriodo) {
        <app-alert-card type="warning" [closable]="true" (close)="alertForaPeriodo = null" class="mb-3 d-block">
            Existem <strong>{{ alertForaPeriodo.quantidade }} lançamentos de cartão</strong> não conciliados em
            <strong>{{ alertForaPeriodo.mesLabel }}</strong>.
            <br>
            <button mat-stroked-button class="btn-secondary" style="margin-top: 8px" (click)="navegarParaMesPendente()">
                Ver conciliações pendentes
            </button>
        </app-alert-card>
        }

        <!-- Filtros + busca -->
        <div class="filtros-row search-area mb-3" [formGroup]="model">

            <!-- Seletor de período -->
            <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
                [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()"
                [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoConciliacaoEnum.Ultimos30Dias">
                {{ periodoLabel }}
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
                <div class="periodo-menu-content">
                    <div>
                        <button type="button" class="periodo-menu-item"
                            (click)="selecionarPeriodo(PeriodoConciliacaoEnum.Hoje); aplicarPeriodo()"
                            [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliacaoEnum.Hoje">
                            <span>hoje</span>
                            @if (periodoSelecionado === PeriodoConciliacaoEnum.Hoje) { <mat-icon>check</mat-icon> }
                        </button>
                        <button type="button" class="periodo-menu-item"
                            (click)="selecionarPeriodo(PeriodoConciliacaoEnum.DaSemana); aplicarPeriodo()"
                            [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliacaoEnum.DaSemana">
                            <span>desta semana</span>
                            @if (periodoSelecionado === PeriodoConciliacaoEnum.DaSemana) { <mat-icon>check</mat-icon> }
                        </button>
                        <button type="button" class="periodo-menu-item"
                            (click)="selecionarPeriodo(PeriodoConciliacaoEnum.DoMes); aplicarPeriodo()"
                            [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliacaoEnum.DoMes">
                            <span>do mês</span>
                            @if (periodoSelecionado === PeriodoConciliacaoEnum.DoMes) { <mat-icon>check</mat-icon> }
                        </button>
                        <button type="button" class="periodo-menu-item"
                            (click)="selecionarPeriodo(PeriodoConciliacaoEnum.Ultimos30Dias); aplicarPeriodo()"
                            [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliacaoEnum.Ultimos30Dias">
                            <span>últimos 30 dias</span>
                            @if (periodoSelecionado === PeriodoConciliacaoEnum.Ultimos30Dias) {
                            <mat-icon>check</mat-icon> }
                        </button>
                        <button type="button" class="periodo-menu-item"
                            (click)="selecionarPeriodo(PeriodoConciliacaoEnum.DoIntervalo); $event.stopPropagation()"
                            [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliacaoEnum.DoIntervalo">
                            <span>do intervalo</span>
                            @if (periodoSelecionado === PeriodoConciliacaoEnum.DoIntervalo) { <mat-icon>check</mat-icon>
                            }
                        </button>

                        @if (periodoSelecionado === PeriodoConciliacaoEnum.DoIntervalo) {
                        <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                            <mat-form-field appearance="outline">
                                <mat-label>De</mat-label>
                                <input matInput [matDatepicker]="pickerDe" placeholder="DD/MM/AAAA"
                                    (input)="onDateInput($event)" formControlName="dataDe" />
                                <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDe></mat-datepicker>
                                @if (model.get('dataDe')?.hasError('required')) {
                                <mat-error>Data inicial obrigatória</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Até</mat-label>
                                <input matInput [matDatepicker]="pickerAte" placeholder="DD/MM/AAAA"
                                    (input)="onDateInput($event)" formControlName="dataAte" />
                                <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                                <mat-datepicker #pickerAte></mat-datepicker>
                                @if (model.get('dataAte')?.hasError('required')) {
                                <mat-error>Data final obrigatória</mat-error>
                                }
                            </mat-form-field>
                            <div class="periodo-intervalo-actions">
                                <button type="button" mat-button class="btn-secondary"
                                    (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                                    Cancelar
                                </button>
                                <button type="button" mat-flat-button class="btn-primary"
                                    (click)="aplicarPeriodo(periodoMenuTrigger)">
                                    Aplicar
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </mat-menu>

            <button mat-stroked-button class="btn-filter" [class.btn-filter--ativo]="filtroNatureza === null"
                (click)="setFiltro(null)">
                Todos ({{ totalTodos }})
            </button>
            <button mat-stroked-button class="btn-filter"
                [class.btn-filter--ativo]="filtroNatureza === naturezaEnum.Entrada"
                (click)="setFiltro(naturezaEnum.Entrada)">
                Estornos ({{ totalEstornos }})
            </button>
            <button mat-stroked-button class="btn-filter"
                [class.btn-filter--ativo]="filtroNatureza === naturezaEnum.Saida"
                (click)="setFiltro(naturezaEnum.Saida)">
                Compras ({{ totalCompras }})
            </button>
        </div>

        <!-- Cabeçalho das colunas -->
        @if (!isLoading && _filtradosVm.length > 0) {
        <div class="colunas-header">
            <span class="col-label col-extrato">Dados do extrato (cartão)</span>
            <span class="col-label col-conciliar"></span>
            <span class="col-label col-acoes">Sugestões ERP / Ações</span>
        </div>
        }

        <!-- Skeleton -->
        @if (isLoading) {
        <div class="skeleton-list">
            @for (i of [1, 2, 3, 4]; track i) {
            <div class="sk-card">
                <div class="sk-painel">
                    <div class="sk-extrato-row">
                        <app-loading-box height="52" width="42"></app-loading-box>
                        <div class="sk-lines">
                            <app-loading-box height="14" marginTop="0"></app-loading-box>
                            <app-loading-box height="11" marginTop="8"></app-loading-box>
                            <app-loading-box height="13" marginTop="10"></app-loading-box>
                        </div>
                    </div>
                    <app-loading-box height="28" width="80" marginTop="16"></app-loading-box>
                </div>
                <div class="sk-centro">
                    <app-loading-box height="24" width="90" marginTop="0"></app-loading-box>
                    <app-loading-box height="36" width="110" marginTop="10"></app-loading-box>
                </div>
                <div class="sk-painel">
                    <div class="sk-btns-row">
                        <app-loading-box height="36" marginTop="0"></app-loading-box>
                        <app-loading-box height="36" marginTop="0"></app-loading-box>
                    </div>
                    <app-loading-box height="52" marginTop="12"></app-loading-box>
                </div>
            </div>
            }
        </div>
        }

        <!-- Empty -->
        @if (!isLoading && _filtradosVm.length === 0) {
        <app-empty-list title="Nenhum lançamento pendente."
            subTitle="Não há extratos do cartão a conciliar no período.">
        </app-empty-list>
        }

        <!-- Lista -->
        @if (!isLoading && _filtradosVm.length > 0) {
        <div class="lancamentos-list">
            @for (vm of _filtradosVm; track vm) {
            <div class="lancamento-card" [class.tem-match]="getSugestaoAtual(vm) !== null">

                <!-- COLUNA ESQUERDA: dados do extrato -->
                <div class="painel-extrato">
                    <div class="lancamento-data"
                        [class.entrada]="vm.item.idNaturezaMovimentacao === naturezaEnum.Entrada"
                        [class.saida]="vm.item.idNaturezaMovimentacao === naturezaEnum.Saida">
                        <span class="data-dia">{{ vm.item.dataTransacao | date: 'dd' }}</span>
                        <span class="data-mes">{{ vm.item.dataTransacao | date: 'MMM' : '' : 'pt-BR' | uppercase
                            }}</span>
                    </div>
                    <div class="lancamento-info">
                        <span class="lancamento-memo">{{ vm.item.memo || '(sem descrição)' }}</span>
                        @if (vm.item.fitid) {
                        <span class="lancamento-fitid">Cód: {{ vm.item.fitid }}</span>
                        }
                        <span class="lancamento-valor"
                            [class.entrada]="vm.item.idNaturezaMovimentacao === naturezaEnum.Entrada"
                            [class.saida]="vm.item.idNaturezaMovimentacao === naturezaEnum.Saida">
                            {{ vm.item.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                            {{ vm.item.valor | currency: 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                    <button mat-button [disabled]="vm.isIgnorando || vm.isConciliando" (click)="ignorar(vm)">
                        @if (vm.isIgnorando) { <mat-spinner diameter="14"></mat-spinner> }
                        @else { Ignorar }
                    </button>
                </div>

                <!-- COLUNA CENTRAL: conciliar -->
                <div class="painel-conciliar">
                    @if (getSugestaoAtual(vm) !== null) {
                    <span class="match-badge match-badge--sim">
                        <mat-icon>auto_awesome</mat-icon> Encontramos
                    </span>
                    }
                    <button mat-flat-button class="btn-primary btn-conciliar"
                        [disabled]="getSugestaoAtual(vm) === null || vm.isConciliando" (click)="conciliarMatch(vm)">
                        @if (vm.isConciliando) { <mat-spinner diameter="16"></mat-spinner> }
                        @else { <span>Conciliar</span> }
                    </button>
                </div>

                <!-- COLUNA DIREITA: com match -->
                @if (getSugestaoAtual(vm); as s) {
                <div class="painel-acoes">
                    <div class="match-card">
                        @if (vm.item.sugestoes.length > 1) {
                        <div class="multi-match-bar">
                            <mat-icon class="multi-match-icon">auto_awesome</mat-icon>
                            <span class="multi-match-label">{{ vm.item.sugestoes.length }} sugestões encontradas</span>
                            <div class="multi-match-dots">
                                @for (s of vm.item.sugestoes; track s; let i = $index) {
                                <span class="multi-match-dot" [class.active]="i === vm.sugestaoIdx"></span>
                                }
                            </div>
                            <button mat-stroked-button class="btn-next-match" (click)="trocarSugestao(vm)">
                                Ver próxima <mat-icon iconPositionEnd>chevron_right</mat-icon>
                            </button>
                        </div>
                        }
                        <div class="match-card-top">
                            <div class="match-data-badge">
                                <span class="data-dia">{{ s.dataReferencia | date: 'dd' }}</span>
                                <span class="data-mes">{{ s.dataReferencia | date: 'MMM' : '' : 'pt-BR' | uppercase
                                    }}</span>
                            </div>
                            <div class="match-info">
                                <span class="match-descricao">{{ stripHtml(s.descricao) }}</span>
                                @if (s.nomeEntidade) {
                                <span class="match-entidade">{{ s.nomeEntidade }}</span>
                                }
                                <div class="match-meta">
                                    <span class="match-valor"
                                        [class.entrada]="vm.item.idNaturezaMovimentacao === naturezaEnum.Entrada"
                                        [class.saida]="vm.item.idNaturezaMovimentacao === naturezaEnum.Saida">
                                        {{ vm.item.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                                        {{ s.valor | currency: 'BRL' : 'symbol' : '1.2-2' }}
                                    </span>
                                    <span class="status-badge badge-cinza">{{ tipoMatchLabel(s.tipoMatch) }}</span>
                                    @if (s.diasDiferenca > 0) {
                                    <span class="match-dias">{{ s.diasDiferenca }} dia(s) de diferença</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="match-card-footer">
                            <button mat-stroked-button class="btn-secondary btn-desvincular"
                                (click)="ignorarSugestao(vm)">
                                <mat-icon>link_off</mat-icon> Desvincular
                            </button>
                        </div>
                    </div>
                </div>
                }

                <!-- COLUNA DIREITA: sem match -->
                @if (getSugestaoAtual(vm) === null) {
                <div class="painel-acoes painel-acoes--sem-match">
                    <app-alert-card type="warning">
                        Nenhum registro correspondente encontrado no ERP.
                    </app-alert-card>

                    <!-- Form inline: Nova CP (SAÍDA) -->
                    @if (vm.acaoAberta === 'novaCp') {
                    <div class="form-inline">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Descrição</mat-label>
                            <input matInput [(ngModel)]="vm.formNovaCp.descricao" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Fornecedor (opcional)</mat-label>
                            <mat-select [(ngModel)]="vm.formNovaCp.idPessoaFornecedor">
                                <mat-option [value]="null">— Nenhum —</mat-option>
                                @for (f of fornecedoresLookup; track f) {
                                <mat-option [value]="f.id">{{ f.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Categoria Financeira (opcional)</mat-label>
                            <mat-select [(ngModel)]="vm.formNovaCp.idCategoriaFinanceira">
                                <mat-option [value]="null">— Nenhuma —</mat-option>
                                @for (c of categoriasLookup; track c) {
                                <mat-option [value]="c.id">{{ c.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="form-inline-actions">
                            <button mat-stroked-button class="btn-secondary" (click)="fecharAcao(vm)">Cancelar</button>
                            <button mat-flat-button class="btn-primary"
                                [disabled]="!vm.formNovaCp.descricao || !vm.formNovaCp.idPessoaFornecedor || !vm.formNovaCp.idCategoriaFinanceira || vm.isConciliando"
                                (click)="confirmarNovaCp(vm)">
                                @if (vm.isConciliando) { <mat-spinner diameter="16"></mat-spinner> }
                                @else { <span>Confirmar CP</span> }
                            </button>
                        </div>
                    </div>
                    }

                    <!-- Form inline: Nova Mov. Estorno (ENTRADA) -->
                    @if (vm.acaoAberta === 'novaMov') {
                    <div class="form-inline">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Descrição (opcional)</mat-label>
                            <input matInput [(ngModel)]="vm.formNovaMov.descricao" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Categoria Financeira (opcional)</mat-label>
                            <mat-select [(ngModel)]="vm.formNovaMov.idCategoriaFinanceira">
                                <mat-option [value]="null">— Nenhuma —</mat-option>
                                @for (c of categoriasLookup; track c) {
                                <mat-option [value]="c.id">{{ c.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Pessoa (opcional)</mat-label>
                            <mat-select [(ngModel)]="vm.formNovaMov.idPessoa">
                                <mat-option [value]="null">— Nenhuma —</mat-option>
                                @for (f of fornecedoresLookup; track f) {
                                <mat-option [value]="f.id">{{ f.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="form-inline-actions">
                            <button mat-stroked-button class="btn-secondary" (click)="fecharAcao(vm)">Cancelar</button>
                            <button mat-flat-button class="btn-primary" [disabled]="vm.isConciliando"
                                (click)="confirmarNovaMov(vm)">
                                @if (vm.isConciliando) { <mat-spinner diameter="16"></mat-spinner> }
                                @else { <span>Confirmar Estorno</span> }
                            </button>
                        </div>
                    </div>
                    }

                    <!-- Botões quando form fechado -->
                    @if (!vm.acaoAberta) {
                    <div class="acoes-row">
                        <button mat-stroked-button class="btn-secondary" (click)="abrirConciliar(vm)">
                            <mat-icon>link</mat-icon> Associar
                        </button>
                        @if (vm.item.idNaturezaMovimentacao === naturezaEnum.Saida) {
                        <button mat-flat-button class="btn-primary" (click)="abrirNovaCp(vm)">
                            <mat-icon>add_circle_outline</mat-icon> Conta a Pagar
                        </button>
                        } @else {
                        <button mat-flat-button class="btn-primary" (click)="abrirNovaMov(vm)">
                            <mat-icon>add_circle_outline</mat-icon> Movi. (Estorno)
                        </button>
                        }
                    </div>
                    }
                </div>
                }

            </div>
            }
        </div>
        }

        <!-- Ver Mais -->
        @if (!isLoading && _filtradosVm.length > 0) {
        <div class="col-12 text-center mt-2 mb-4">
            <button mat-button [disabled]="!_temMais || isLoadingMais" (click)="proximaPagina()">
                @if (isLoadingMais) {
                <mat-spinner diameter="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>
        }

    </div>
</div>